"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _TextField = _interopRequireDefault(require("@sprinx/react-mui-fields/TextField"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({
      width: '48%',
      display: 'flex',
      flexDirection: 'column'
    }, theme.breakpoints.down('sm'), {
      width: '100%'
    }),
    label: {
      position: 'relative',
      transform: 'translate(0,0) !important',
      marginBottom: theme.spacing(0.5),
      '&>span': {
        color: theme.palette.error.main
      }
    }
  };
}, {
  name: 'FormTextField'
});

function FormTextField(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      _ref$Component = _ref.Component,
      Component = _ref$Component === void 0 ? _TextField.default : _ref$Component,
      disabled = _ref.disabled,
      error = _ref.error,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      handleChange = _ref.onChange,
      type = _ref.type,
      value = _ref.value,
      required = _ref.required,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "Component", "disabled", "error", "id", "label", "name", "onChange", "type", "value", "required"]);
  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, rest, {
    className: (0, _clsx.default)(classes.root, className),
    type: type,
    name: name,
    id: id,
    disabled: disabled,
    label: label,
    value: value,
    onChange: handleChange,
    error: error,
    variant: "outlined",
    required: required,
    InputLabelProps: {
      classes: {
        root: classes.label
      }
    },
    InputProps: {
      notched: false
    }
  }));
}

process.env.NODE_ENV !== "production" ? FormTextField.propTypes = {
  classes: _propTypes.default.shape({
    label: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  Component: _propTypes.default.elementType,
  disabled: _propTypes.default.bool,
  error: _propTypes.default.oneOfType([_propTypes.default.shape({}), _propTypes.default.string]),
  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  label: _propTypes.default.string,
  name: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  required: _propTypes.default.bool,
  type: _propTypes.default.string,
  value: _propTypes.default.string
} : void 0;
FormTextField.defaultProps = {
  classes: undefined,
  className: undefined,
  Component: undefined,
  disabled: false,
  error: undefined,
  id: undefined,
  label: undefined,
  name: undefined,
  required: false,
  type: 'text',
  value: undefined
};
var _default = FormTextField;
exports.default = _default;